module.exports = __webpack_public_path__ + "static/img/2363_phase_function_Paper_PointsHejduk_Prediction.74def00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2363_phase_function_Paper_PointsHejduk_Prediction.png
// module id = IOY1
// module chunks = 0